import cleanObject from "app/shared-components/util/cleanObject";

const generateUserSchema = ({ user, includeContext }) => {
  const host = window.location.protocol + '//' + window.location.host;
  const baseUrl = host + "/public/profile/";
  const screenNameUrl = user.screenName ? baseUrl + user.screenName : null;
  const idUrl = baseUrl + user.id;
  const canonicalUrl = screenNameUrl ? screenNameUrl : idUrl;
  const description = user.providerInfo?.description ? user.providerInfo?.description : user.about;

  const sameAsUrls = [canonicalUrl, idUrl].filter((url, index, arr) => url && arr.indexOf(url) === index);

  const schema = {
    ...(includeContext && { "@context": "https://schema.org" }),
    "@type": "Person",
    "name": user.name,
    ...(user.screenName && { "alternateName": user.screenName }),
    "identifier": user.id,
    ...(description && { "description": description }),
    ...(user.profileImageUrl && { "image": user.profileImageUrl }),
    "sameAs": sameAsUrls
  };

  const cleanedSchema = cleanObject(schema);
  // Ensure sameAs remains an array after cleaning
  if (cleanedSchema.sameAs && !Array.isArray(cleanedSchema.sameAs)) {
    cleanedSchema.sameAs = Object.values(cleanedSchema.sameAs);
  }
  
  return cleanedSchema;
};

export default generateUserSchema;